import React, { Component } from 'react';
import UserStore from '../stores/UserStore';
import { observer } from 'mobx-react';

class Sidebar extends Component {

  state = {

    menu:[]
  }


  render() {
      return (
        <div class="sidebar sidebar-light sidebar-main sidebar-expand-md">

          {/* Sidebar mobile toggler */}
          <div class="sidebar-mobile-toggler text-center">
            <a href="#" class="sidebar-mobile-main-toggle">
              <i class="icon-arrow-left8"></i>
            </a>
            Navigation
            <a href="#" class="sidebar-mobile-expand">
              <i class="icon-screen-full"></i>
              <i class="icon-screen-normal"></i>
            </a>
          </div>
          {/* /sidebar mobile toggler */}


          {/* Sidebar content */}
          <div class="sidebar-content">

            {/* User menu */}
            {UserStore.isLoggedIn &&
            <div class="sidebar-user">
              <div class="card-body">
                <div class="media">
                  <div class="mr-3">
                      {/*<a href="#"><img src={UserStore.picture} width="38" height="38" class="rounded-circle" alt=""></img></a>*/}
                  </div>

                  <div class="media-body">
                    <div class="media-title font-weight-semibold">{UserStore.username}</div>
                    <div class="font-size-xs opacity-50">
                      {/* */}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          }
            {/* /user menu */}


            {/* Main navigation */}
            <div class="card card-sidebar-mobile">
              <ul class="nav nav-sidebar" data-nav-type="accordion">
              <li class="nav-item-header"><div class="text-uppercase font-size-xs line-height-xs">Main</div> <i class="icon-menu" title="main"></i></li>
              {UserStore.services.map(function(row,i){
                if (row['pages'] && row['active']){
                  return   <li class="nav-item nav-item-submenu nav-item-expanded nav-item-open" >
                      <a href="#" class="nav-link"><i class={row['icon']}></i> <span>{row['name']}</span></a>

                      <ul class="nav nav-group-sub" data-submenu-title={row['name']}>
                       {row['pages'].map(function(page,i){
                        return  <li class="nav-item"><a href={page['url']} target={row['target']}  class="nav-link">{page['name']}</a></li>
                       })}
                      </ul>
                    </li>
                  }else if(row['active']){
                    return <li class="nav-item">
                      <a href={row['url']} target={row['target']} class="nav-link">
                        <i class={row['icon']}></i>
                        <span>{row['name']}</span>
                      </a>
                    </li>
                  }
              })}
                {this.state.menu.map(function(section,i){
                  return <>
                <li class="nav-item-header"><div class="text-uppercase font-size-xs line-height-xs">{section['name']}</div> <i class="icon-menu" title={section['name']}></i></li>

                {section['components'].map(function(row,i){
                  if (row['pages']){
                    return   <li class="nav-item nav-item-submenu nav-item-expanded nav-item-open" >
                        <a href="#" class="nav-link"><i class={row['icon']}></i> <span>{row['name']}</span></a>

                        <ul class="nav nav-group-sub" data-submenu-title={row['name']}>
                         {row['pages'].map(function(page,i){
                          return  <li class="nav-item"><a href={page['url']} target={row['target']}  class="nav-link">{page['name']}</a></li>
                         })}
                        </ul>
                      </li>
                    }else{
                      return <li class="nav-item">
                        <a href={row['url']} target={row['target']} class="nav-link">
                          <i class={row['icon']}></i>
                          <span>{row['name']}</span>
                        </a>
                      </li>
                    }
                })}
                </>
              })}

              </ul>
            </div>
            {/* /main navigation */}

          </div>
          {/* /sidebar content */}

        </div>
	     )
  }
}

export default observer(Sidebar);
